/* PagingWorkTargetDeviceFeed.js */

const PagingFeed = require("../../../../../../lib/PagingFeed");

class PagingWorkTargetDeviceFeed extends PagingFeed {
    _getFeed() {
        return this._EntityDef.startQueryFeed(
            this._userSession.activeOrganization.id,
            this._EntityDef.getEntityType(),
            this._filter,
            this._fields,
            this._sort,
            { skip: 0, limit: this._pageSize * 2 }
        );
    }
}

module.exports = PagingWorkTargetDeviceFeed;
